'use client';

import { useParams } from 'next/navigation';

import { Breadcrumb, Container, PublicPageHeading } from '@/components';
import { useCategories, useTranslation } from '@/hooks';
import { routes } from '@/statics';

type RouteParams = {
  category: string;
};
const StaticSections: React.FC = () => {
  const { t } = useTranslation('pages');
  const { category } = useParams<RouteParams>();
  const { data: categoriesData } = useCategories();
  const currentCategory = categoriesData?.find(
    (item) => item.code === Number(category)
  );

  return (
    <>
      {currentCategory && (
        <>
          <Container gap={{ base: 2.5, md: 5 }}>
            <Breadcrumb
              list={[
                { title: t('home.home'), href: routes.home.url },
                {
                  title: routes.categories.title,
                  href: routes.categories.url,
                },
                {
                  title: currentCategory?.title,
                  href: routes.category.href(currentCategory?.code),
                },
              ]}
            />
          </Container>
          <PublicPageHeading title={currentCategory?.title} />
        </>
      )}
    </>
  );
};
export default StaticSections;
